import styled from 'styled-components';
import { kievitSlabBook } from '@zocdoc-frontend-common/styles-typography';
import { navy } from '@zocdoc/branding/colors';

/**
 * @deprecated Use the mezzanine component '@zocdoc-mezzanine/components-modal'
 */
const Paragraph = styled.p`
    ${kievitSlabBook(16, 24)}
    color: ${navy};
`;

export { Paragraph as default, Paragraph as ModalBodyCopy };
